<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';

    // TODO: replace this graphql with Svelte store
    import { companies as getCompanies } from "../../Me.svelte";
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import NewCompanyDialog from "../dialogs/NewCompanyDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import CompanyDropdown from "./CompanyDropdown.svelte";
    import Button from "./Button.svelte";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';

    // allow external code to set selected company
    export let selected = "";
    export let selectedName;
    export let companies = [];

    $: hasCompanies = !!companies.length;

    // whether to show the dialog for creating new companies
    let openCreateCompanyDialog = false;

    const dispatch = createEventDispatcher();

    function showCreateCompanyDialog() {
        openCreateCompanyDialog = true;
    }

    // receive new company from dialog, set the selected id
    // to the new instance and reload companies from server
    function handleNew(evt) {
        console.log("[CompanyDropdownCreator] received new company from NewCompanyDialog")
        console.log(evt);
        // TODO: set new company id to selected
        //reloadCompanies();
        openCreateCompanyDialog = false;
        dispatch("new", evt);
    }

</script>

{#if companies.length}
    <CompanyDropdown on:new={handleNew} bind:selected={selected} {companies} allowIndeterminate={false} help=""/>
{:else}
    <Button
            text="Create new company..."
            id="open-create-company-dialog-button"
            on:click={showCreateCompanyDialog}
            options={{style: "margin-bottom: 0;"}}
    />
{/if}

<!-- overlay new dialog to create new company -->
<Overlay show={openCreateCompanyDialog} background="darken">
    <NewCompanyDialog on:new={handleNew} show={openCreateCompanyDialog}/>
</Overlay>